import Cookies from "js-cookie";

class RDGateway {
  sendToRDStation(data, redirectLink) {
    if (data.form_identifier === "cadastro-oportunidade-expansao") {
      const rdData = { ...data, cf_page_url: window.location.origin + window.location.pathname };
      delete rdData.form_identifier;

      this.sendToRD(rdData).then((responseRD) => {
        if (responseRD && redirectLink) {
          window.location = redirectLink;
        }
      });

      return;
    }

    const dataCookies = {
      cf_origem: Cookies.get("mutm_source") || "",
      cf_midia: Cookies.get("mutm_medium") || "",
      cf_campanha: Cookies.get("mutm_campaign") || "",
      cf_utm_term: Cookies.get("mutm_term") || "",
      cf_utm_content: Cookies.get("mutm_content") || "",
      cf_fbclid: Cookies.get("mfbclid") || "",
      cf_glcid: Cookies.get("mgclid") || "",
      cf_gad_campaignid: Cookies.get("madscampaignid") || "",
      cf_wbraid: Cookies.get("mwbraid") || "",
      cf_gbraid: Cookies.get("mgbraid") || "",
      cf_page_url: window.location.origin + window.location.pathname,
      cf_ga4_client_id: Cookies.get("_ga") || "",
      cf_ga4_muser_id: Cookies.get("MUserID") || "",
    };

    this.hashEmail(data.email).then((hashedEmail) => {
      const enrichedData = { ...dataCookies, ...data, cf_email_hash: hashedEmail };

      for (const [key, value] of Object.entries(enrichedData)) {
        enrichedData[key] = String(value);
      }

      this.sendDataLayer(enrichedData);

      Promise.all([this.sendToRD(enrichedData), this.sendToHubspot(enrichedData)]).then(([responseRD, responseHubspot]) => {
        if (responseRD || responseHubspot) {
          if (redirectLink) {
            window.location = redirectLink;
          }
        } else {
          //alert("Ooops! Tivemos um pequeno problema no recebimento do formulário. Por favor, tente novamente.")
        }
      });
    });
  }

  sendDataLayer(enrichedData) {
    try {
      window.dataLayer = window.dataLayer || [];
      let dataLayerObject = {
        event: "event_track",
        event_category: enrichedData.event_category || "form_submit",
        event_action: enrichedData.event_action || "",
        event_label: (enrichedData.event_label || "").replace(/-/g, "_"),
        MUserId: "",
        emailHash: enrichedData.cf_email_hash || "",
        email: enrichedData.email || "",
        codigo_parceiro: enrichedData.cf_codigo_do_parceiro_meus_pedidos || "",
        event_cnpj: enrichedData.cf_cnpj ? "sim" : "nao",
      };


      if (this.getCompanyType(enrichedData)) {
        dataLayerObject.event_companyType = this.getCompanyType(enrichedData);
      }

      dataLayer.push(dataLayerObject);
      return true;
    } catch (error) {
      console.error(error);
    }
  }

  gaexpDataSplit(data) {
    try {
      let arr = data.split(".");
      let value = "";
      return value.concat(arr[2], ".", arr[4]);
    } catch (error) {
      return "";
    }
  }

  async hashEmail(email) {
    try {
      const encoder = new TextEncoder();
      const emailBytes = encoder.encode(email.toLowerCase());
      const hashBytes = await crypto.subtle.digest("SHA-256", emailBytes);
      const hashArray = Array.from(new Uint8Array(hashBytes));
      const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
      return hashHex.slice(0, 36);
    } catch (error) {
      return "";
    }
  }

  getCompanyType(type) {
    if (type && type.cf_atividade_da_empresa) {
      if (type.cf_atividade_da_empresa === "Representante comercial" || type.cf_atividade_da_empresa ===  "Representação Comercial") {
        return "representacao_comercial";
      } else if (type.cf_atividade_da_empresa === "Distribuição") {
        return "distribuicao";
      } else if (type.cf_atividade_da_empresa === "Indústria") {
        return "industria";
      } else if (type.cf_atividade_da_empresa === "Outra" || type.cf_atividade_da_empresa === "Outro") {
        return "outro";
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  sendToRD(enrichedData) {
    const data = JSON.stringify({
      event_type: "CONVERSION",
      event_family: "CDP",
      payload: enrichedData,
    });

    return fetch("https://api.rd.services/platform/conversions?api_key=abSCjrNCSWZvTKmxPEuGiTMxdFFtMlJbyBqX", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer",
      },
      body: data,
    })
      .then((response) => {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  }

  sendToHubspot(enrichedData) {
    var _hsq = (window._hsq = window._hsq || []);
    _hsq.push([
      "identify",
      {
        conversion_identifier: enrichedData.conversion_identifier || "",
        company: enrichedData.company_name || "",
        nome: enrichedData.name || "",
        email: enrichedData.email || "",
        telefone: enrichedData.personal_phone || "",
        time: enrichedData.cf_time || "",
        atividade_da_empresa: enrichedData["cf_atividade_da_empresa"] || "",
        numero_de_vendedores: enrichedData["cf_numero_de_vendedores"] || "",
      },
    ]);

    var hubspotForm = {
      fields: [
        {
          objectTypeId: "0-1",
          name: "email",
          value: enrichedData.email || "",
        },
        {
          objectTypeId: "0-1",
          name: "firstname",
          value: enrichedData.name || "",
        },
        {
          objectTypeId: "0-1",
          name: "identificador",
          value: enrichedData.conversion_identifier || "",
        },
        {
          objectTypeId: "0-1",
          name: "company",
          value: enrichedData.company_name || "",
        },
        {
          objectTypeId: "0-1",
          name: "phone",
          value: enrichedData.personal_phone || "",
        },
        {
          objectTypeId: "0-1",
          name: "time",
          value: enrichedData.cf_time || "",
        },
        {
          objectTypeId: "0-1",
          name: "atividade_da_empresa",
          value: enrichedData["cf_atividade_da_empresa"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "numero_de_vendedores",
          value: enrichedData["cf_numero_de_vendedores"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "cf_origem",
          value: enrichedData["cf_origem"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "midia",
          value: enrichedData["cf_midia"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "campanha",
          value: enrichedData["cf_campanha"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "termo",
          value: enrichedData["cf_utm_term"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "conteudo",
          value: enrichedData["cf_utm_content"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "fbclid",
          value: enrichedData["cf_fbclid"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "gclid",
          value: enrichedData["cf_glcid"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "gad_campaignid",
          value: enrichedData["cf_gad_campaignid"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "cf_wbraid",
          value: enrichedData["cf_wbraid"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "gbraid",
          value: enrichedData["cf_gbraid"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "tipo_de_conversao",
          value: enrichedData["cf_tipo_de_conversao"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "codigo_do_parceiro_meus_pedidos",
          value: enrichedData["cf_codigo_do_parceiro_meus_pedidos"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "city",
          value: enrichedData["city"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "erp_utilizado",
          value: enrichedData["cf_erp_utilizado"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "descricao_da_necessidade",
          value: enrichedData["cf_descricao_da_necessidade"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "carteira_clientes_canais",
          value: enrichedData["cf_carteira_clientes_canais"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "nome_do_parceiro__canais1_",
          value: enrichedData["cf_nome_do_parceiro_canais1"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "clientes_ativos__canais_",
          value: enrichedData["cf_clientes_ativos_canais"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "ramo_de_atuacao__canais_",
          value: enrichedData["cf_ramo_de_atuacao_canais"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "percentual_perfil_ind_dist__canais_",
          value: enrichedData["cf_percentual_perfil_ind_dist_canais"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "observacoes",
          value: enrichedData["cf_observacoes"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "unidade_de_negocio_salesforce",
          value: enrichedData["cf_unidade_de_negocio_salesforce"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "cf_isoptimizetest",
          value: enrichedData["cf_isoptimizetest"] || "",
        },
        {
          objectTypeId: "0-1",
          name: "empresa",
          value: enrichedData.company_name || "",
        },
        {
          objectTypeId: "0-1",
          name: "telefone",
          value: enrichedData.personal_phone || "",
        },
        {
          objectTypeId: "0-1",
          name: "email_hash",
          value: enrichedData.cf_email_hash || "",
        },
        {
          objectTypeId: "0-1",
          name: "cf_cnpj",
          value: enrichedData.cf_cnpj || "",
        },
        {
          objectTypeId: "0-1",
          name: "cf_honeypot",
          value: enrichedData.cf_honeypot || "",
        },
      ],
      context: {
        pageUri: window.location.origin + window.location.pathname,
        pageName: document.title,
      },
    };

    return fetch("https://api.hsforms.com/submissions/v3/integration/submit/21596284/632b7e2d-915b-4384-86eb-678c7bb78e4a", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(hubspotForm),
    })
      .then((response) => {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  }
}

export default RDGateway;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/gateways/RDGateway.js